/* eslint-disable*/
import React, { useEffect, useRef } from 'react';
import { message } from 'antd';
import Big from "big.js";
import './index.less';

const Caculator: React.FC = () => {
    const endNumber = useRef(true);
    const mem = useRef(0);
    const carry = useRef(10);
    const hexnum = useRef('0123456789abcdef');
    const angle = useRef('');
    const stack = useRef<any>('');
    const level = useRef('0');
    const layer = useRef(0);

    useEffect(() => {
        (document as any).getElementById('angle').checked = true;
        (document as any).getElementById('ten-scale').checked = true;
    }, []);

    // 十进制转换
    const todec = (num: any, oldcarry: any) => {
        if (oldcarry == 10 || num == 0) {
            return num;
        }

        const neg = num.charAt(0) == '-';

        if (neg) {
            num = num.substr(1);
        }

        let newnum = 0;

        for (let index = 1; index <= num.length; index++) {
            newnum = newnum * oldcarry + hexnum.current.indexOf(num.charAt(index - 1));
        }

        if (neg) {
            newnum = -newnum;
        }

        return newnum;
    };

    const decto = (num: any, newcarry: any) => {
        const neg = num < 0;
        if (newcarry == 10 || num == 0) {
            return num;
        }
        num = '' + Math.abs(num);
        let newnum = '';
        while (num != 0) {
            newnum = hexnum.current.charAt(num % newcarry) + newnum;
            num = Math.floor(num / newcarry);
        }
        if (neg) newnum = '-' + newnum;
        return newnum;
    };

    // 数学运算和位运算
    const cypher = (left: any, join: any, right: any) => {
        // 使用 Big.js 处理高精度计算
        const bigLeft = Big(left);
        const bigRight = Big(right);
    
        switch (join) {
            case "+":
                return decto(bigLeft.plus(bigRight).toString(), carry.current);
            case "-":
                return decto(bigLeft.minus(bigRight).toString(), carry.current);
            case "*":
                return decto(bigLeft.times(bigRight).toString(), carry.current);
            case "/":
                if (bigRight.eq(0)) {
                    message.error("除数不能为零");
                    return left;
                }
                return decto(bigLeft.div(bigRight).toString(), carry.current);
            case "%":
                return decto(bigLeft.mod(bigRight).toString(), carry.current);
            case "&":
                return decto((Number(left) & Number(right)).toString(), carry.current);
            case "|":
                return decto((Number(left) | Number(right)).toString(), carry.current);
            case "^":
                return decto(bigLeft.pow(Number(right)).toString(), carry.current);
            case "x":
                return decto((Number(left) ^ Number(right)).toString(), carry.current);
            case "<":
                return decto((Number(left) << Number(right)).toString(), carry.current);
            default:
                message.error("不支持的运算符");
                return left;
        }
    }

    // 表达式解析
    const parse = (string: any) => {
        if (string.match(/^(.*\d[+\-*/%^&|x<])?([+-]?[0-9a-f.]+)([+\-*/%^&|x<])([+-]?[0-9a-f.]+)$/)) {
            return RegExp.$1 + cypher(RegExp.$2, RegExp.$3, RegExp.$4);
        }
        return string;
    };

    const dms = (n: any) => {
        const neg = n < 0;
        n = Math.abs(n);
        const d = Math.floor(n);
        const m = Math.floor(60 * (n - d));
        const s = (n - d) * 60 - m;
        let cdms = d + m / 100 + s * 0.006;
        if (neg) cdms = -cdms;
        return cdms;
    };

    const deg = (n: any) => {
        const neg = n < 0;
        n = Math.abs(n);
        const d = Math.floor(n);
        const m = Math.floor((n - d) * 100);
        const s = (n - d) * 100 - m;
        let cdeg = d + m / 60 + s / 36;
        if (neg) cdeg = -cdeg;
        return cdeg;
    };

    const degressToRadians = (degress: any) => {
        return (degress * Math.PI) / 180;
    };

    const factorial = (n: any) => {
        n = Math.abs(parseInt(n));
        let fac = 1;
        for (; n > 0; n -= 1) fac *= n;
        return fac;
    };

    const radiansToDegress = (radians: any) => {
        return (radians * 180) / Math.PI;
    };

    // 函数计算
    const funcalc = (fun: any, num: any) => {
        // with (Math) {
        if (fun == 'pi') return Math.PI;
        if (fun == 'e') return Math.E;
        if (fun == 'abs') return Math.abs(num);
        if (fun == 'ceil') return Math.ceil(num);
        if (fun == 'round') return Math.round(num);
        if (fun == 'floor') return Math.floor(num);
        if (fun == 'deci') return num - Math.floor(num);
        if (fun == 'ln' && num > 0) return Math.log(num);
        if (fun == 'exp') return Math.exp(num);
        if (fun == 'log' && num > 0) return Math.log(num) * Math.LOG10E;
        if (fun == 'expdec') return Math.pow(10, num);
        if (fun == 'cube') return num * num * num;
        if (fun == 'cubt') return Math.pow(num, 1 / 3);
        if (fun == 'sqr') return num * num;
        if (fun == 'sqrt' && num >= 0) return Math.sqrt(num);
        if (fun == '!') return factorial(num);
        if (fun == 'recip' && num != 0) return 1 / num;
        if (fun == 'dms') return dms(num);
        if (fun == 'deg') return deg(num);
        if (fun == '~') return ~num;
        if (angle.current == 'd') {
            if (fun == 'sin') return Math.sin(degressToRadians(num));
            if (fun == 'cos') return Math.cos(degressToRadians(num));
            if (fun == 'tan') return Math.tan(degressToRadians(num));
            if (fun == 'arcsin' && Math.abs(num) <= 1) return radiansToDegress(Math.asin(num));
            if (fun == 'arccos' && Math.abs(num) <= 1) return radiansToDegress(Math.acos(num));
            if (fun == 'arctan') return radiansToDegress(Math.atan(num));
        } else {
            if (fun == 'sin') return Math.sin(num);
            if (fun == 'cos') return Math.cos(num);
            if (fun == 'tan') return Math.tan(num);
            if (fun == 'arcsin' && Math.abs(num) <= 1) return Math.asin(num);
            if (fun == 'arccos' && Math.abs(num) <= 1) return Math.acos(num);
            if (fun == 'arctan') return Math.atan(num);
        }

        if (fun == 'hypsin') return (Math.exp(num) - Math.exp(0 - num)) * 0.5;
        if (fun == 'hypcos') return (Math.exp(num) + Math.exp(-num)) * 0.5;
        if (fun == 'hyptan') return (Math.exp(num) - Math.exp(-num)) / (Math.exp(num) + Math.exp(-num));
        if (fun == 'ahypsin' || fun == 'hypcos' || fun == 'hyptan') {
            message.error('对不起,公式还没有查到!');
            return num;
        }
        message.error('超出函数定义范围');
        return num;
    };

    // 数字键
    const inputkey = (key: string) => {
        const index = key.charCodeAt(0);
        if (
            (carry.current == 2 && (index == 48 || index == 49)) ||
            (carry.current == 8 && index >= 48 && index <= 55) ||
            (carry.current == 10 && ((index >= 48 && index <= 57) || index == 46)) ||
            (carry.current == 16 && ((index >= 48 && index <= 57) || (index >= 97 && index <= 102)))
        ) {
            if (endNumber.current) {
                endNumber.current = false;
                (document as any).calc.display.value = key;
            } else if ((document as any).calc.display.value == null || (document as any).calc.display.value == '0') {
                (document as any).calc.display.value = key;
            } else {
                (document as any).calc.display.value += key;
            }
        }
    };

    const inputshift = () => {
        if ((document as any).calc.shiftf.checked) {
            (document as any).calc.bt.value = 'deg ';
            (document as any).calc.ln.value = 'exp ';
            (document as any).calc.log.value = 'expd';
            if ((document as any).calc.hypf.checked) {
                (document as any).calc.sin.value = 'ahs ';
                (document as any).calc.cos.value = 'ahc ';
                (document as any).calc.tan.value = 'aht ';
            } else {
                (document as any).calc.sin.value = 'asin';
                (document as any).calc.cos.value = 'acos';
                (document as any).calc.tan.value = 'atan';
            }
            (document as any).calc.sqr.value = 'x^.5';
            (document as any).calc.cube.value = 'x^.3';
            (document as any).calc.floor.value = '小数';
        } else {
            (document as any).calc.bt.value = 'd.ms';
            (document as any).calc.ln.value = ' ln ';
            (document as any).calc.log.value = 'log ';
            if ((document as any).calc.hypf.checked) {
                (document as any).calc.sin.value = 'hsin';
                (document as any).calc.cos.value = 'hcos';
                (document as any).calc.tan.value = 'htan';
            } else {
                (document as any).calc.sin.value = 'sin ';
                (document as any).calc.cos.value = 'cos ';
                (document as any).calc.tan.value = 'tan ';
            }
            (document as any).calc.sqr.value = 'x^2 ';
            (document as any).calc.cube.value = 'x^3 ';
            (document as any).calc.floor.value = '取整';
        }
    };

    // 函数键
    const inputfunction = (fun: any, shiftfun: any) => {
        endNumber.current = true;

        if ((document as any).calc.shiftf.checked) {
            (document as any).calc.display.value = decto(
                funcalc(shiftfun, todec((document as any).calc.display.value, carry.current)),
                carry.current
            );
        } else {
            (document as any).calc.display.value = decto(
                funcalc(fun, todec((document as any).calc.display.value, carry.current)),
                carry.current
            );
        }

        (document as any).calc.shiftf.checked = false;

        (document as any).calc.hypf.checked = false;

        inputshift();
    };

    const changeSign = () => {
        if ((document as any).calc.display.value != '0') {
            if ((document as any).calc.display.value.substr(0, 1) == '-') {
                (document as any).calc.display.value = (document as any).calc.display.value.substr(1);
            } else {
                (document as any).calc.display.value = '-' + (document as any).calc.display.value;
            }
        }
    };

    const inputtrig = (trig: any, arctrig: any, hyp: any, archyp: any) => {
        if ((document as any).calc.hypf.checked) {
            inputfunction(hyp, archyp);
        } else {
            inputfunction(trig, arctrig);
        }
    };

    // 运算符
    const operation = (join: any, newlevel: any) => {
        endNumber.current = true;
        let temp = stack.current.substr(stack.current.lastIndexOf('(') + 1) + (document as any).calc.display.value;

        while (newlevel != 0 && newlevel <= level.current.charAt(level.current.length - 1)) {
            temp = parse(temp);
            level.current = level.current.slice(0, -1);
        }

        if (temp.match(/^(.*\d[+\-*/%^&|x])?([+-]?[0-9a-f.]+)$/)) {
            (document as any).calc.display.value = RegExp.$2;
        }

        stack.current = stack.current.substr(0, stack.current.lastIndexOf('(') + 1) + temp + join;
        (document as any).calc.operator.value = ' ' + join + ' ';
        level.current = level.current + newlevel;
    };

    // 括号
    const addbracket = () => {
        endNumber.current = true;
        (document as any).calc.display.value = 0;
        stack.current = stack.current + '(';
        (document as any).calc.operator.value = '   ';
        level.current = level.current + 0;
        layer.current += 1;
        (document as any).calc.bracket.value = '(=' + layer.current;
    };

    const disbracket = () => {
        endNumber.current = true;
        let temp = stack.current.substr(stack.current.lastIndexOf('(') + 1) + (document as any).calc.display.value;
        while (+level.current.charAt(level.current.length - 1) > 0) {
            temp = parse(temp);
            level.current = level.current.slice(0, -1);
        }
        (document as any).calc.display.value = temp;
        stack.current = stack.current.substr(0, stack.current.lastIndexOf('('));
        (document as any).calc.operator.value = '   ';
        level.current = level.current.slice(0, -1);
        layer.current -= 1;
        if (layer.current > 0) {
            (document as any).calc.bracket.value = '(=' + layer;
        } else {
            (document as any).calc.bracket.value = '';
        }
    };

    // 等号
    const result = () => {
        endNumber.current = true;
        while (layer.current > 0) disbracket();
        let temp = stack.current + (document as any).calc.display.value;
        while (+level.current.charAt(level.current.length - 1) > 0) {
            temp = parse(temp);
            level.current = level.current.slice(0, -1);
        }
        (document as any).calc.display.value = temp;
        (document as any).calc.bracket.value = '';
        (document as any).calc.operator.value = '';
        stack.current = '';
        level.current = '0';
    };

    // 修改键
    const backspace = () => {
        if (!endNumber.current) {
            if ((document as any).calc.display.value.length > 1) {
                (document as any).calc.display.value = (document as any).calc.display.value.substring(
                    0,
                    (document as any).calc.display.value.length - 1
                );
            } else {
                (document as any).calc.display.value = 0;
            }
        }
    };
    const clearping = () => {
        (document as any).calc.display.value = 0;
    };
    const clearall = () => {
        (document as any).calc.display.value = 0;
        endNumber.current = true;
        stack.current = '';
        level.current = '0';
        layer.current = 0;
        (document as any).calc.operator.value = '';
        (document as any).calc.bracket.value = '';
    };
    // 转换键
    const inputChangCarry = (newcarry: any) => {
        endNumber.current = true;
        (document as any).calc.display.value = decto(todec((document as any).calc.display.value, carry.current), newcarry);
        carry.current = newcarry;
        (document as any).calc.sin.disabled = carry.current != 10;
        (document as any).calc.cos.disabled = carry.current != 10;
        (document as any).calc.tan.disabled = carry.current != 10;
        (document as any).calc.bt.disabled = carry.current != 10;
        (document as any).calc.pi.disabled = carry.current != 10;
        (document as any).calc.e.disabled = carry.current != 10;
        (document as any).calc.kp.disabled = carry.current != 10;
        (document as any).calc.k2.disabled = carry.current <= 2;
        (document as any).calc.k3.disabled = carry.current <= 2;
        (document as any).calc.k4.disabled = carry.current <= 2;
        (document as any).calc.k5.disabled = carry.current <= 2;
        (document as any).calc.k6.disabled = carry.current <= 2;
        (document as any).calc.k7.disabled = carry.current <= 2;
        (document as any).calc.k8.disabled = carry.current <= 8;
        (document as any).calc.k9.disabled = carry.current <= 8;
        (document as any).calc.ka.disabled = carry.current <= 10;
        (document as any).calc.kb.disabled = carry.current <= 10;
        (document as any).calc.kc.disabled = carry.current <= 10;
        (document as any).calc.kd.disabled = carry.current <= 10;
        (document as any).calc.ke.disabled = carry.current <= 10;
        (document as any).calc.kf.disabled = carry.current <= 10;
    };

    const inputChangAngle = (angletype: any) => {
        endNumber.current = true;
        angle.current = angletype;
        if (angle.current == 'd') (document as any).calc.display.value = radiansToDegress((document as any).calc.display.value);
        else (document as any).calc.display.value = degressToRadians((document as any).calc.display.value);
        endNumber.current = true;
    };

    // 存储器部分
    const clearmemory = () => {
        mem.current = 0;
        (document as any).calc.memory.value = '   ';
    };
    const getmemory = () => {
        endNumber.current = true;

        (document as any).calc.display.value = decto(mem.current, carry.current);
    };

    const putmemory = () => {
        endNumber.current = true;
        if ((document as any).calc.display.value != 0) {
            mem.current = todec((document as any).calc.display.value, carry.current);
            (document as any).calc.memory.value = ' M ';
        } else {
            (document as any).calc.memory.value = '   ';
        }
    };

    const addmemory = () => {
        endNumber.current = true;
        mem.current = mem.current + +todec((document as any).calc.display.value, carry.current);
        if (mem.current == 0) {
            (document as any).calc.memory.value = '   ';
        } else {
            (document as any).calc.memory.value = ' M ';
        }
    };

    const multimemory = () => {
        endNumber.current = true;
        mem.current = mem.current * parseFloat(todec((document as any).calc.display.value, carry.current));
        if (mem.current == 0) {
            (document as any).calc.memory.value = '   ';
        } else {
            (document as any).calc.memory.value = ' M ';
        }
    };

    return (
        <div className="calc">
            <form className="calc-w" name="calc">
                <table className="cw" id="kxjsq">
                    <tbody>
                        <tr>
                            <td align="center" className="td-center">
                                <input className="cw-input" name="display" readOnly size={40} value="0" />
                            </td>
                        </tr>
                        <tr>
                            <td className="td-center" style={{ height: 50, textAlign: 'center' }}>
                                <table style={{ width: 650, margin: 'auto' }}>
                                    <tbody>
                                        <tr>
                                            <td className="scale-system">
                                                <div>
                                                    <input
                                                        className="cw-select"
                                                        name="carry"
                                                        onClick={() => inputChangCarry(16)}
                                                        type="radio"
                                                    />
                                                    十六进制
                                                </div>

                                                <div>
                                                    <input
                                                        className="cw-select"
                                                        id="ten-scale"
                                                        name="carry"
                                                        onClick={() => inputChangCarry(10)}
                                                        readOnly
                                                        type="radio"
                                                    />
                                                    十进制
                                                </div>

                                                <div>
                                                    <input
                                                        className="cw-select"
                                                        name="carry"
                                                        onClick={() => inputChangCarry(8)}
                                                        readOnly
                                                        type="radio"
                                                    />
                                                    八进制
                                                </div>

                                                <div>
                                                    {' '}
                                                    <input
                                                        className="cw-select"
                                                        name="carry"
                                                        onClick={() => inputChangCarry(2)}
                                                        readOnly
                                                        type="radio"
                                                    />
                                                    二进制
                                                </div>
                                            </td>
                                            <td />
                                            <td className="degree">
                                                <div onClick={() => inputChangAngle('d')}>
                                                    <input className="cw-select" id="angle" name="angle" readOnly type="radio" value="d" />
                                                    角度制
                                                </div>

                                                <div onClick={() => inputChangAngle('r')}>
                                                    <input className="cw-select" name="angle" readOnly type="radio" value="r" />
                                                    弧度制
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td align="center" className="td-center">
                                <table style={{ width: 659, marginBottom: 6 }}>
                                    <tbody>
                                        <tr>
                                            <td className="on-file">
                                                <input className="cw-select" name="shiftf" onClick={() => inputshift()} type="checkbox" />
                                                上档功能
                                                <input className="cw-select" name="hypf" onClick={() => inputshift()} type="checkbox" />
                                                双曲函数
                                            </td>
                                            <td className="fnc-info">
                                                <input className="cw-show" name="bracket" readOnly size={3} />
                                                <input className="cw-show" name="memory" readOnly size={3} />
                                                <input className="cw-show" name="operator" readOnly size={3} />
                                            </td>
                                            <td align="right" className="td-right">
                                                <input
                                                    className="cw-tpl"
                                                    onClick={() => backspace()}
                                                    readOnly
                                                    type="button"
                                                    value=" 退格 "
                                                />
                                                <input
                                                    className="cw-tpl"
                                                    onClick={() => clearping()}
                                                    readOnly
                                                    type="button"
                                                    value=" 清屏 "
                                                />
                                                <input className="cw-tpl" onClick={() => clearall()} readOnly type="button" value=" 全清" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td align="center" className="td-center">
                                <table style={{ marginBottom: 6 }}>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <table>
                                                    <tbody>
                                                        <tr
                                                            style={{
                                                                textAlign: 'center',
                                                            }}
                                                        >
                                                            <td>
                                                                <input
                                                                    className="cw-fn"
                                                                    name="pi"
                                                                    onClick={() => inputfunction('pi', 'pi')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" PI "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-fn"
                                                                    name="e"
                                                                    onClick={() => inputfunction('e', 'e')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" E  "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-fn"
                                                                    name="bt"
                                                                    onClick={() => inputfunction('dms', 'deg')}
                                                                    readOnly
                                                                    type="button"
                                                                    value="d.ms"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr
                                                            style={{
                                                                textAlign: 'center',
                                                            }}
                                                        >
                                                            <td>
                                                                <input
                                                                    className="cw-fn"
                                                                    onClick={() => addbracket()}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" (  "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-fn"
                                                                    onClick={() => disbracket()}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" )  "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-fn"
                                                                    name="ln"
                                                                    onClick={() => inputfunction('ln', 'exp')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" ln "
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr
                                                            style={{
                                                                textAlign: 'center',
                                                            }}
                                                        >
                                                            <td>
                                                                <input
                                                                    className="cw-fn"
                                                                    name="sin"
                                                                    onClick={() => inputtrig('sin', 'arcsin', 'hypsin', 'ahypsin')}
                                                                    readOnly
                                                                    type="button"
                                                                    value="sin "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-fn"
                                                                    onClick={() => operation('^', 7)}
                                                                    readOnly
                                                                    type="button"
                                                                    value="x^y "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-fn"
                                                                    name="log"
                                                                    onClick={() => inputfunction('log', 'expdec')}
                                                                    readOnly
                                                                    type="button"
                                                                    value="log "
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr
                                                            style={{
                                                                textAlign: 'center',
                                                            }}
                                                        >
                                                            <td>
                                                                <input
                                                                    className="cw-fn"
                                                                    name="cos"
                                                                    onClick={() => inputtrig('cos', 'arccos', 'hypcos', 'ahypcos')}
                                                                    readOnly
                                                                    type="button"
                                                                    value="cos "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-fn"
                                                                    name="cube"
                                                                    onClick={() => inputfunction('cube', 'cubt')}
                                                                    readOnly
                                                                    type="button"
                                                                    value="x^3 "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-fn"
                                                                    onClick={() => inputfunction('!', '!')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" n! "
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr
                                                            style={{
                                                                textAlign: 'center',
                                                            }}
                                                        >
                                                            <td>
                                                                <input
                                                                    className="cw-fn"
                                                                    name="tan"
                                                                    onClick={() => inputtrig('tan', 'arctan', 'hyptan', 'ahyptan')}
                                                                    type="button"
                                                                    value="tan "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-fn"
                                                                    name="sqr"
                                                                    onClick={() => inputfunction('sqr', 'sqrt')}
                                                                    readOnly
                                                                    type="button"
                                                                    value="x^2 "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-fn"
                                                                    onClick={() => inputfunction('recip', 'recip')}
                                                                    readOnly
                                                                    type="button"
                                                                    value="1/x "
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                            <td style={{ width: 30 }} />
                                            <td>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    className="cw-tpl"
                                                                    onClick={() => putmemory()}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" 储存 "
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    className="cw-tpl"
                                                                    onClick={() => getmemory()}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" 取存 "
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    className="cw-tpl"
                                                                    onClick={() => addmemory()}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" 累存 "
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    className="cw-tpl"
                                                                    onClick={multimemory}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" 积存 "
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <input
                                                                    className="cw-tpl"
                                                                    onClick={clearmemory}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" 清存 "
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                            <td style={{ width: 30 }} />
                                            <td>
                                                <table>
                                                    <tbody>
                                                        <tr
                                                            style={{
                                                                textAlign: 'center',
                                                            }}
                                                        >
                                                            <td>
                                                                <input
                                                                    className="cw-num"
                                                                    name="k7"
                                                                    onClick={() => inputkey('7')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" 7 "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-num"
                                                                    name="k8"
                                                                    onClick={() => inputkey('8')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" 8 "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-num"
                                                                    name="k9"
                                                                    onClick={() => inputkey('9')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" 9 "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-x"
                                                                    onClick={() => operation('/', 6)}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" / "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-tpl"
                                                                    onClick={() => operation('%', 6)}
                                                                    readOnly
                                                                    type="button"
                                                                    value="取余"
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-tpl"
                                                                    onClick={() => operation('&amp;', 3)}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" 与 "
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr
                                                            style={{
                                                                textAlign: 'center',
                                                            }}
                                                        >
                                                            <td>
                                                                <input
                                                                    className="cw-num"
                                                                    name="k4"
                                                                    onClick={() => inputkey('4')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" 4 "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-num"
                                                                    name="k5"
                                                                    onClick={() => inputkey('5')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" 5 "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-num"
                                                                    name="k6"
                                                                    onClick={() => inputkey('6')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" 6 "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-x"
                                                                    onClick={() => operation('*', 6)}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" * "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-tpl"
                                                                    name="floor"
                                                                    onClick={() => inputfunction('floor', 'deci')}
                                                                    readOnly
                                                                    type="button"
                                                                    value="取整"
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-tpl"
                                                                    onClick={() => operation('|', 1)}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" 或 "
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr
                                                            style={{
                                                                textAlign: 'center',
                                                            }}
                                                        >
                                                            <td>
                                                                <input
                                                                    className="cw-num"
                                                                    onClick={() => inputkey('1')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" 1 "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-num"
                                                                    name="k2"
                                                                    onClick={() => inputkey('2')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" 2 "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-num"
                                                                    name="k3"
                                                                    onClick={() => inputkey('3')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" 3 "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-x"
                                                                    onClick={() => operation('-', 5)}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" - "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-tpl"
                                                                    onClick={() => operation('&lt;', 4)}
                                                                    readOnly
                                                                    type="button"
                                                                    value="左移"
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-tpl"
                                                                    onClick={() => inputfunction('~', '~')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" 非 "
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr
                                                            style={{
                                                                textAlign: 'center',
                                                            }}
                                                        >
                                                            <td>
                                                                <input
                                                                    className="cw-num"
                                                                    onClick={() => inputkey('0')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" 0 "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-num"
                                                                    onClick={() => changeSign()}
                                                                    readOnly
                                                                    type="button"
                                                                    value="+/-"
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-num"
                                                                    name="kp"
                                                                    onClick={() => inputkey('.')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" . "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-x"
                                                                    onClick={() => operation('+', 5)}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" + "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-fn cw-enter"
                                                                    onClick={result}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" ＝ "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-tpl"
                                                                    onClick={() => operation('x', 2)}
                                                                    readOnly
                                                                    type="button"
                                                                    value="异或"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr
                                                            style={{
                                                                textAlign: 'center',
                                                            }}
                                                        >
                                                            <td>
                                                                <input
                                                                    className="cw-x"
                                                                    disabled
                                                                    name="ka"
                                                                    onClick={() => inputkey('a')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" A "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-x"
                                                                    disabled
                                                                    name="kb"
                                                                    onClick={() => inputkey('b')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" B "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-x"
                                                                    disabled
                                                                    name="kc"
                                                                    onClick={() => inputkey('c')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" C "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-x"
                                                                    disabled
                                                                    name="kd"
                                                                    onClick={() => inputkey('d')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" D "
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-x"
                                                                    disabled
                                                                    name="ke"
                                                                    onClick={() => inputkey('e')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" E　"
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className="cw-x"
                                                                    disabled
                                                                    name="kf"
                                                                    onClick={() => inputkey('f')}
                                                                    readOnly
                                                                    type="button"
                                                                    value=" F　"
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>
        </div>
    );
};

export default Caculator;
